import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const testRoutes: RouteRecordRaw = {
  path: "/test",
  component: Layout,
  redirect: "/test/testPaperPackageList",
  name: "TestManagement",
  meta: {
    title: "资源管理",
    icon: "testPaper",
    permissionKey: "test",
  },
  children: [
    {
      path: "testPaperPackageList",
      name: "TestPaperPackageList",
      component: () =>
        import("@/views/Workbench/test-management/test-paper-package-list/index.vue"),
      meta: {
        title: "试卷包",
        permissionKey: "test:testPaperPackageList",
      },
    },
    {
      path: "testList",
      name: "TestList",
      component: () =>
        import("@/views/Workbench/test-management/test-list/index.vue"),
      meta: {
        title: "试卷库",
        permissionKey: "test:testList",
      },
    },
    {
      path: "testEditor",
      name: "TestEditor",
      component: () =>
        import("@/views/Workbench/test-management/test-editor/index.vue"),
      meta: {
        title: "新增试卷",
        hidden: true,
        permissionKey: "test:testEditor",
      },
    },
    {
      path: "testAnswer",
      name: "TestAnswer",
      component: () =>
        import("@/views/Workbench/test-management/test-answer/index.vue"),
      meta: {
        title: "标答",
        hidden: true,
        permissionKey: "test:testAnswer",
      },
    },
    {
      path: "schoolTestPaperUseList",
      name: "SchoolTestPaperUseList",
      component: () =>
        import("@/views/Workbench/test-management/school-test-paper-use-list/index.vue"),
      meta: {
        title: "已授权列表",
        permissionKey: "test:schoolTestPaperUseList",
      },
    },
    {
      path: "testPaperUseAuth",
      name: "TestPaperUseAuth",
      component: () =>
        import("@/views/Workbench/test-management/test-paper-auth/index.vue"),
      meta: {
        title: "使用授权",
        hidden: true,
        permissionKey: "test:testPaperUseAuth",
      },
    },
    {
      path: "resourceTemplateList",
      name: "ResourceTemplateList",
      component: () =>
        import("@/views/Workbench/test-management/resource-template-list/index.vue"),
      meta: {
        title: "资源模板",
        permissionKey: "test:resourceTemplateList",
      },
    },
    {
      path: "resourceTemplateEditor",
      name: "ResourceTemplateEditor",
      component: () =>
        import("@/views/Workbench/test-management/resource-template-editor/index.vue"),
      meta: {
        title: "新增资源模板",
        hidden: true,
        permissionKey: "test:resourceTemplateEditor",
      },
    },
  ],
};

export default testRoutes;
